<template>
  <div class="share-page-dropdown">
    <input type="text" readonly ref="input" :value="httpsPreviewVideoUrl" />

    <single-share-link-button
      v-if="isImpededTemplatizer"
      :show-generated-link="showGeneratedLink"
      :is-copied="isCopied"
      @on-copy-link="onCopyWhenSingle"
    />
    <wt-dropdown-view
      v-else
      type="menu-up fixed"
      ref="menu"
      :disabled="!showGeneratedLink"
      :disableClickOutside="disableClickOutside"
      @toggle="onOpenDropDown"
    >
      <template slot="label">
        <wt-google-like-loader
          v-if="!showGeneratedLink"
          class="-default -toggle-icon"
        />
        <i v-else class="wticon wticon-share3 wt2-text-lm -toggle-icon" />
        <span
          >{{
            (showGeneratedLink
              ? 'fullPreview.SHARE_YOUR_STORY'
              : 'fullPreview.COPY_GENERATING') | culture
          }}
        </span>
      </template>

      <template slot="view">
        <ul>
          <FrameIoDropdown
            ref="frameIo"
            @close="closeMenu"
            :story="story"
            :previewVideoUrl="previewVideoUrl"
          />
          <li>
            <div class="-link -brand">
              <wt-button
                type="transparent"
                class="-custom"
                :text="'slack.shareOnSlack' | culture"
                @click="openSlack"
              >
              </wt-button>
              <img
                class="-logo-hashtag"
                src="/resources/img/social/slack-hashtag.svg"
                alt=""
                @click="openSlack"
              />
            </div>
          </li>
          <li>
            <div class="-link">
              <input
                type="text"
                readonly
                ref="input"
                :value="httpsPreviewVideoUrl"
              />
              <wt-button
                type="transparent"
                icon="wticon-link2"
                class="-custom"
                :disabled="isCopied"
                :text="linkText"
                @click="copyLink"
              >
              </wt-button>
            </div>
          </li>
        </ul>
      </template>
    </wt-dropdown-view>
  </div>
</template>

<script>
import FrameIoDropdown from './FrameIoDropdown.vue';
import { mapGetters } from 'vuex';
import SingleShareLinkButton from 'v/FullPreview/SingleShareLinkButton.vue';

export default {
  name: 'sharePageDropdown',

  props: {
    story: { type: Object, required: true },
    showGeneratedLink: { type: Boolean, default: false },
    previewVideoUrl: { type: String, default: '' },
  },

  components: {
    SingleShareLinkButton,
    FrameIoDropdown,
  },

  data() {
    return {
      disableClickOutside: false,
      isCopied: false,
    };
  },

  computed: {
    ...mapGetters('user', ['isImpededTemplatizer']),

    httpsPreviewVideoUrl() {
      return app.generatePublishUrl(this.story.id);
    },

    linkText() {
      if (this.isCopied) {
        return app.culture.get('fullPreview.COPIED');
      } else if (this.showGeneratedLink) {
        return app.culture.get('fullPreview.COPY_PREVIEW');
      }
      return '';
    },
  },

  methods: {
    onOpenDropDown(isOpen) {
      this.$refs?.frameIo?.resetMenu();
      if (isOpen) {
        this.$emit('pause-playing');
      }

      if (isOpen) {
        this.confirm();
      }
    },

    confirm() {
      if (app.stash.get('doNotShowPreviewOverrideDialog')) {
        return Promise.resolve();
      }

      this.disableClickOutside = true;
      return app.dialog
        .confirm({
          type: app.dialog.types.CONFIRM_1,
          title: app.culture.get('fullPreview.PREVIEW_OVERRIDES_WARNING_TITLE'),
          description: app.culture.get(
            'fullPreview.PREVIEW_OVERRIDES_WARNING_DESC'
          ),
          buttonYesText: app.culture.get('fullPreview.PREVIEW_GOT_IT'),
          showCheckbox: true,
          checkboxLabel: app.culture.get('fullPreview.DO_NOT_SHOW_ME_AGAIN'),
          checkboxChecked: true,
        })
        .then((data) => {
          if (data.metadata && !!data.metadata.checkboxValue) {
            app.stash.set('doNotShowPreviewOverrideDialog', true);
          }
          this.disableClickOutside = false;
        });
    },

    closeMenu() {
      this.$refs.menu.close();
    },

    openSlack() {
      this.$refs?.frameIo?.resetMenu();
      this.disableClickOutside = true;
      this.mixinShowViewInModal({
        type: 'small',
        component: 'wt-slack',
        componentPropsData: {
          video: this.story,
          videoType: 'draft',
        },
      }).$on('close', () => {
        this.disableClickOutside = false;
        this.$refs.menu && this.$refs.menu.close && this.$refs.menu.close();
      });
    },

    onCopyWhenSingle() {
      this.confirm().then(this.copyLink);
    },

    copyLink() {
      this.$refs?.frameIo?.resetMenu();
      const input = this.$refs.input;

      if (input && input.select && !this.isCopied) {
        input.select();
        input.blur();

        try {
          // copy text
          document.execCommand('copy');
          this.isCopied = true;

          _.delay(() => {
            this.isCopied = false;
          }, app.TIME.SECOND * 3);
        } catch (err) {
          console.warn(`fullPreview::copyLink->fail ${JSON.stringify(err)}`);
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.share-page-dropdown {
  input {
    position: absolute;
    top: -1000px;
    left: -1000px;
  }
}
</style>
